import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const CompanySelector = ({ companysData, selectedCompanyID, onChange }) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}
    >
      <FormControl fullWidth>
        <InputLabel id="company-select-label">
          Selecciona una empresa
        </InputLabel>
        <Select
          labelId="company-select-label"
          value={selectedCompanyID}
          onChange={(e) => onChange(e.target.value)}
        >
          {companysData.map((company) => (
            <MenuItem key={company.id} value={company.id}>
              {company.companyName} ({company.companyRut})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CompanySelector;
